<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-2">
        <h1 class="display-2 font-weight-bold mb-0">Listado de Tareas</h1>
      </v-col>
    </v-row>
    <template
      v-if="
        ($store.getters.usuario.idRol == 2 ||
          $store.getters.usuario.idRol == 5) &&
        selectedTab == 0
      "
    >
      <v-container>
        <DateRangePicker @dates-selected="handleDatesSelected" />
      </v-container>
    </template>

    <template v-if="$store.getters.usuario.idRol == 5 && selectedTab == 1">
      <v-autocomplete
        v-model="contratistaSeleccionado"
        :items="listaContratistas"
        item-value="idContratista"
        item-text="descripcionContratista"
        required
        attach
        prepend-icon="mdi-truck"
        label="Contratista"
        no-data-text="No se encontraron contratistas"
        hint="Seleccione la contratista para ver sus tareas"
        persistent-hint
        @change="cambioContratista"
      ></v-autocomplete>
    </template>
    <v-row>
      <v-col cols="12">
        <template v-if="$store.getters.usuario.idRol != 4">
          <v-toolbar text color="white">
            <v-tabs
              v-model="selectedTab"
              fixed-tabs
              background-color="indigo"
              dark
            >
              <v-tab
                v-for="(tipoReclamo, index) in listadotiposdetareas"
                :key="index"
                @click="cambiarTab(index)"
                @change="cambiarTab(index)"
              >
                {{ tipoReclamo.nombre }}
              </v-tab>

              <!-- <v-tab
              v-for="(tipoReclamo, index) in listadotiposdetareas"
              :key="index"
            >
              {{ tipoReclamo.nombre }}
            </v-tab> -->
            </v-tabs>

            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="green"
                  small
                  fab
                  dark
                  @click="generarExcelTareas()"
                >
                  <v-icon>mdi-microsoft-excel</v-icon>
                </v-btn>
                <!-- </router-link> -->
              </template>
              <span>Generar Excel</span>
            </v-tooltip>
            <!-- <template
              v-if="$store.getters.usuario.idRol == 2 && selectedTab == 0"
            > -->
            <template
              v-if="
                ($store.getters.usuario.idRol == 2 ||
                  $store.getters.usuario.idRol == 5) &&
                selectedTab == 0
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="purple"
                    small
                    fab
                    dark
                    @click="asignarTodasLasTareas()"
                    class="ml-5"
                  >
                    <v-icon>mdi-tally-mark-4</v-icon>
                  </v-btn>
                  <!-- </router-link> -->
                </template>
                <span>Asignar todas las tareas</span>
              </v-tooltip>
            </template>

            <template
              v-if="
                ($store.getters.usuario.idRol == 2 ||
                  $store.getters.usuario.idRol == 5) &&
                selectedTab == 3
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="generarCertificadoManoObra()"
                    class="ml-5"
                  >
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <!-- </router-link> -->
                </template>
                <span>Generar Certificado de Mano de Obra</span>
              </v-tooltip>
            </template>

            <!-- <template v-if="selectedTab == 0">
            <v-btn color="primary" @click="agregarTarea">
              Agregar Item Constructivo
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </template> 
          <template v-if="selectedTab == 1">
            <v-btn color="primary" @click="agregarVersion">
              Agregar Version
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </template>-->
          </v-toolbar>
        </template>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item
            v-for="(item, index) in listadotiposdetareas"
            :key="index"
          >
            <!-- <template
              v-if="$store.getters.usuario.idRol == 2 && selectedTab == 0"
            > -->
            <template
              v-if="
                ($store.getters.usuario.idRol == 2 ||
                  $store.getters.usuario.idRol == 5) &&
                selectedTab == 0
              "
            >
              <v-data-table
                :headers="headersTareas"
                :items="tablaTareas"
                :search="buscarTareas"
                :custom-filter="filtrarTareas"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @update:sort-by="updateSortBy"
                class="elevation-1 mt-0"
                no-results-text="No se encontraron resultados"
                no-data-text="No ha cargado Ningun Dato"
                :footer-props="$store.state.traduccionTabla"
                item-value="Categoria"
              >
                <!-- <template v-slot:header="{ header }">
                  <th class="custom-header">{{ header.text }}</th>
                </template> -->
                <template v-slot:[`item.identificador`]="{ item }">
                  <v-chip :color="getColor(item.motivo)">
                    {{ item.identificador }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-text-field
                    v-model="buscarTareas"
                    label="Buscar Tareas"
                    class="pa-2"
                  ></v-text-field>
                </template>

                <template v-slot:[`item.vencimiento`]="{ item }">
                  <td class="text-start">
                    {{ fechaConvertida(item.vencimiento) }}
                  </td>
                </template>

                <template v-slot:[`item.inicioTramite`]="{ item }">
                  <td class="text-start">
                    {{ fechaConvertida(item.inicioTramite) }}
                  </td>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <!-- <v-icon small class="mr-2" @click="editItem(item)" >mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="green"
                        small
                        fab
                        dark
                        @click="asignarTareaContratista(item)"
                      >
                        <v-icon>mdi-account-arrow-left</v-icon>
                      </v-btn>
                      <!-- </router-link> -->
                    </template>
                    <span>Asignar Tareas a Contratista</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="blue"
                        small
                        fab
                        dark
                        class="ml-2"
                        @click="verDetalleTarea(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <!-- </router-link> -->
                    </template>
                    <span>Ver Detalle</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>

            <!-- <template
              v-if="
                ($store.getters.usuario.idRol == 2 && selectedTab == 1) ||
                ($store.getters.usuario.idRol == 3 && selectedTab == 0)
              "
            > -->
            <template
              v-if="
                (($store.getters.usuario.idRol == 2 ||
                  $store.getters.usuario.idRol == 5) &&
                  selectedTab == 1) ||
                ($store.getters.usuario.idRol == 3 && selectedTab == 0)
              "
            >
              <v-data-table
                :headers="headersTareasAsignadasTipo"
                :items="tablaTareasAsignadas"
                :search="buscarTareasAsignadas"
                :custom-filter="filtrarTareasAsignadas"
                item-value="Categoria"
                class="elevation-1 mt-2"
                no-results-text="No se encontraron resultados"
                no-data-text="No ha cargado Ningun Dato"
                :footer-props="$store.state.traduccionTabla"
              >
                <template v-slot:[`item.estado`]="{ item }">
                  {{ getTextoEstado(item.estado) }}
                </template>

                <template v-slot:[`item.identificador`]="{ item }">
                  <v-chip :color="getColor(item.motivo)">
                    {{ item.identificador }}
                  </v-chip>
                </template>

                <!-- <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th v-for="h in headers" :class="h.class">
                        <span>{{ h.text }}</span>
                      </th>
                    </tr>
                  </thead>
                </template> -->
                <template v-slot:top>
                  <v-text-field
                    v-model="buscarTareasAsignadas"
                    label="Buscar Tareas Asignadas"
                    class="pa-2"
                  ></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <template
                    v-if="
                      ($store.getters.usuario.idRol == 3 && selectedTab == 0) ||
                      ($store.getters.usuario.idRol == 5 && selectedTab == 1)
                    "
                  >
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="10"
                          small
                          fab
                          color="orange"
                          dark
                          class="mx-2"
                          @click="asignarTareaCuadrilla(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark>
                            mdi-account-multiple-plus-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Asignar Tarea a Cuadrilla</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="
                      ($store.getters.usuario.idRol == 2 ||
                        $store.getters.usuario.idRol == 5) &&
                      selectedTab == 1
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          small
                          fab
                          dark
                          v-if="item.estado == 1"
                          @click="cancelarTareaModal(item)"
                        >
                          <v-icon>mdi-cancel</v-icon>
                        </v-btn>
                        <!-- </router-link> -->
                      </template>
                      <span>Cancelar Tarea</span>
                    </v-tooltip>
                  </template>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="blue"
                        small
                        fab
                        dark
                        class="ml-2"
                        @click="verDetalleTarea(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <!-- </router-link> -->
                    </template>
                    <span>Ver Detalle</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>

            <template
              v-if="$store.getters.usuario.idRol == 3 && selectedTab == 1"
            >
              <v-data-table
                :headers="headersTareasDespachadas"
                :items="tablaTareasDespachadas"
                :search="buscarTareasDespachadas"
                :custom-filter="filtrarTareasDespachadas"
                item-value="Categoria"
                class="elevation-1 mt-2"
                no-results-text="No se encontraron resultados"
                no-data-text="No ha cargado Ningun Dato"
                :footer-props="$store.state.traduccionTabla"
              >
                <template v-slot:[`item.identificador`]="{ item }">
                  <v-chip :color="getColor(item.motivo)">
                    {{ item.identificador }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-text-field
                    v-model="buscarTareasDespachadas"
                    label="Buscar Tareas Despachadas"
                    class="pa-2"
                  ></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="blue"
                        small
                        fab
                        dark
                        class="ml-2"
                        @click="verDetalleTarea(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <!-- </router-link> -->
                    </template>
                    <span>Ver Detalle</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>

            <template
              v-if="
                (($store.getters.usuario.idRol == 2 ||
                  $store.getters.usuario.idRol == 5) &&
                  selectedTab == 2) ||
                ($store.getters.usuario.idRol == 3 && selectedTab == 2)
              "
            >
              <v-data-table
                :headers="headersTareasConcluidasVisibles"
                :items="tablaTareasConcluidas"
                :search="buscarTareasConcluidas"
                :custom-filter="filtrarTareasConcluidas"
                class="elevation-1 mt-2"
                no-results-text="No se encontraron resultados"
                no-data-text="No ha cargado Ningun Dato"
                :footer-props="$store.state.traduccionTabla"
              >
                <template v-slot:[`item.identificador`]="{ item }">
                  <v-chip :color="getColor(item.motivo)">
                    {{ item.identificador }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-text-field
                    v-model="buscarTareasConcluidas"
                    label="Buscar Tareas Concluidas"
                    class="pa-2"
                  ></v-text-field>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <template
                    v-if="
                      ($store.getters.usuario.idRol == 2 ||
                        $store.getters.usuario.idRol == 5) &&
                      selectedTab == 2
                    "
                  >
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="10"
                          small
                          fab
                          dark
                          color="green"
                          class="mx-2"
                          @click="inspeccionarTarea(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-eye-check-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Inspeccionar Tarea</span>
                    </v-tooltip>
                  </template>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="blue"
                        small
                        fab
                        dark
                        class="ml-2"
                        @click="verDetalleTarea(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                      <!-- </router-link> -->
                    </template>
                    <span>Ver Detalle</span>
                  </v-tooltip>
                </template>
                <!-- <template v-slot:no-data>
                  <v-btn color="primary" @click="ListarReclamos">Reset</v-btn>
                </template> -->
              </v-data-table>
            </template>

            <template v-if="selectedTab == 3">
              <v-data-table
                :headers="headersTareasInspeccionadas"
                :items="tablaTareasInspeccionadas"
                :search="buscarTareasInspeccionadas"
                :custom-filter="filtrarTareasInspeccionadas"
                class="elevation-1 mt-2"
                no-results-text="No se encontraron resultados"
                no-data-text="No ha cargado Ningun Dato"
                :footer-props="$store.state.traduccionTabla"
              >
                <template v-slot:[`item.identificador`]="{ item }">
                  <v-chip :color="getColor(item.motivo)">
                    {{ item.identificador }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-text-field
                    v-model="buscarTareasInspeccionadas"
                    label="Buscar Tareas Inspeccionadas"
                    class="pa-2"
                  ></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <template v-if="selectedTab == 3">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="10"
                          small
                          fab
                          dark
                          color="blue"
                          class="mx-2"
                          @click="verDetalleTareaInspeccionada(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-eye </v-icon>
                        </v-btn>
                      </template>
                      <span>Ver Detalle Tarea</span>
                    </v-tooltip>
                  </template>
                </template>
                <!-- <template v-slot:no-data>
                  <v-btn color="primary" @click="ListarReclamos">Reset</v-btn>
                </template> -->
              </v-data-table>
            </template>
            <template v-if="selectedTab == 4">
              <v-data-table
                :headers="headersTareasCanceladas"
                :items="tablaTareasCanceladas"
                :search="buscarTareasCanceladas"
                :custom-filter="filtrarTareasCanceladas"
                class="elevation-1 mt-2"
                no-results-text="No se encontraron resultados"
                no-data-text="No ha cargado Ningun Dato"
                :footer-props="$store.state.traduccionTabla"
              >
                <template v-slot:[`item.identificador`]="{ item }">
                  <v-chip :color="getColor(item.motivo)">
                    {{ item.identificador }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-text-field
                    v-model="buscarTareasCanceladas"
                    label="Buscar Tareas Canceladas"
                    class="pa-2"
                  ></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <template v-if="selectedTab == 3">
                    <v-tooltip left color="green">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="10"
                          small
                          fab
                          color="green"
                          dark
                          class="mx-2"
                          @click="AbrirModalModificacion(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-pencil </v-icon>
                        </v-btn>
                      </template>
                      <span>Modificar Cuadrilla</span>
                    </v-tooltip>
                  </template>

                  <template v-if="selectedTab == 3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="black"
                          class="mr-2"
                          @click="
                            AbrirDialogoAgregarCodigoCierreDocumento(item)
                          "
                        >
                          mdi-briefcase-plus
                        </v-icon>
                      </template>
                      <span>Agregar Códigos de Cierre</span>
                    </v-tooltip>
                  </template>

                  <template v-if="selectedTab == 3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="brown"
                          class="mr-2"
                          @click="AbrirDialogoAnular(item)"
                        >
                          mdi-package-variant-plus
                        </v-icon>
                      </template>
                      <span>Agregar Materiales</span>
                    </v-tooltip>
                  </template>
                </template>
                <!-- <template v-slot:no-data>
                  <v-btn color="primary" @click="ListarReclamos">Reset</v-btn>
                </template> -->
              </v-data-table>
            </template>
          </v-tab-item>
        </v-tabs-items>
        <template v-if="$store.getters.usuario.idRol == 4">
          <v-data-table
            :headers="headersTareasDespachadasCuadrilla"
            :items="tablaTareasDespachadasCuadrilla"
            :search="buscarTareasDespachadasCuadrilla"
            :custom-filter="filtrarTareasDespachadasCuadrilla"
            class="elevation-1 mt-0"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
            item-value="Categoria"
          >
            <template v-slot:[`item.identificador`]="{ item }">
              <v-chip :color="getColor(item.motivo)">
                {{ item.identificador }}
              </v-chip>
            </template>

            <template v-slot:top>
              <v-text-field
                v-model="buscarTareasDespachadasCuadrilla"
                label="Buscar Tareas Despachadas Cuadrilla"
                class="pa-2"
              ></v-text-field>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <!-- <v-icon small class="mr-2" @click="editItem(item)" >mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="blue"
                    small
                    fab
                    dark
                    class="mr-2"
                    @click="verDetalleTarea(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <!-- </router-link> -->
                </template>
                <span>Ver Detalle</span>
              </v-tooltip>
              <template v-if="item.estadoInicio == 0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="green"
                      small
                      fab
                      dark
                      @click="iniciarTareaCuadrilla(item)"
                    >
                      <v-icon>mdi-ray-start</v-icon>
                    </v-btn>
                  </template>
                  <span>Iniciar Tarea</span>
                </v-tooltip>
              </template>

              <template v-if="item.estadoInicio == 1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="red"
                      small
                      fab
                      dark
                      class="mr-2"
                      @click="finalizarTareaCuadrilla(item)"
                    >
                      <v-icon>mdi-ray-end</v-icon>
                    </v-btn>
                  </template>
                  <span>Finalizar Tarea</span>
                </v-tooltip>
              </template>
              <template v-if="item.estadoInicio == 1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="orange"
                      small
                      fab
                      class="mr-2"
                      dark
                      @click="opcionesTarea(item)"
                    >
                      <v-icon>mdi-stop-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span
                    >Finalizar Parcialmente la Tarea / Suspender la tarea</span
                  >
                </v-tooltip>
              </template>
            </template>
          </v-data-table>
        </template>
      </v-col>
    </v-row>

    <!-- <modal-Items-Constructivos
      ref="modalTareas"
      @recargarTareas="recargarTareas"
    /> -->

    <modalTarea
      ref="abrirModalInsert_Update"
      @recargarListado="recargarListado"
      @recargarListadoAsignados="recargarListadoAsignados"
    ></modalTarea>

    <modalTareaDetalle ref="modalTareaDetalle"></modalTareaDetalle>

    <dialog-mensaje ref="dialogMensaje" @resultado="cancelarTarea" />

    <modalTareaCuadrilla ref="modalTareaCuadrilla" @resultado="cancelarTarea" />

    <modalCertificadoManoObra
      ref="modalCertificadoManoObra"
    ></modalCertificadoManoObra>

    <!-- <modalTareaCuadrilla
      ref="abrirModalTareaCuadrilla"
      @recargarTareas="recargarTareas"
    ></modalTareaCuadrilla> -->
  </v-container>
</template>

<script>
//import modalTareas from "@/componentes/proyectosNT/normasTecnicas/dialogTareas.vue";
import modalTarea from "@/modulos/Tareas/componentes/modalTareas.vue";
import modalTareaDetalle from "@/modulos/Tareas/componentes/modalTareaDetalle.vue";
import modalCertificadoManoObra from "@/modulos/Tareas/componentes/modalImprimirCertificadoManoObra.vue";
//import modalTareaCuadrilla from "@/modulos/Tareas/componentes/modalTareasCuadrilla.vue";
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";
import ExcelJS from "exceljs";
import DateRangePicker from "@/components/DateRangePicker.vue";
//import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import modalTareaCuadrilla from "@/modulos/Tareas/componentes/modalTareaCuadrilla.vue";

//import format from "date-fns/format";

export default {
  selectedDates: [],
  tabSeleccionada: 0,
  menuDateTimePicker: false,
  components: {
    modalTarea,
    dialogMensaje,
    modalTareaDetalle,
    DateRangePicker,
    modalTareaCuadrilla,
    modalCertificadoManoObra,
  },
  data: () => ({
    contratistaSeleccionado: "",
    listaContratistas: [],
    sortBy: "vencimiento",
    sortDesc: false,
    fillBsqReclamo: {
      fechadesde: new Date().toISOString().substr(0, 10), //DEBE OBTENER LA FECHA ANTERIOR
      fechahasta: new Date().toISOString().substr(0, 10),
    },
    iniciarTarea: false,
    tablaTareas: [],
    tablaTareasAsignadas: [],
    tablaTareasDespachadas: [],
    tablaTareasConcluidas: [],
    tablaTareasInspeccionadas: [],
    tablaTareasCanceladas: [],
    tablaTareasDespachadasCuadrilla: [],

    buscarTareas: "",
    buscarTareasAsignadas: "",
    buscarTareasDespachadas: "",
    buscarTareasConcluidas: "",
    buscarTareasCanceladas: "",
    buscarTareasDespachadasCuadrilla: "",
    buscarTareasInspeccionadas: "",

    fechadesde: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 2,
    )
      .toISOString()
      .substr(0, 10),
    fechahasta: new Date().toISOString().substr(0, 10),
    agrupacion: "1",
    itemscriterios: [
      { Id: 1, Descripcion: "Identificador" },
      { Id: 2, Descripcion: "Medidor" },
      { Id: 3, Descripcion: "Cliente" },
      { Id: 4, Descripcion: "Numero de Reclamo" },
      { Id: 5, Descripcion: "Guardia" },
      // {Id: 6, Descripcion: "Zona"},
      // {Id: 7, Descripcion: "Barrio"},
      // {Id: 8, Descripcion: "Seta"},
    ],
    idTareaCancelar: "",
    fecha: "",
    criteriobusqueda: 0,
    valorbusqueda: "",
    verreclamosanteriores: 0,
    listadotiposdetareas: [],
    listareclamos: [],
    listareclamos2: [],
    headersTareasDespachadasCuadrilla: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Vencimiento", value: "vencimiento", class: "black white--text" },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
      // { text: "Distrito", value: "distrito" },
      // { text: "Radio", value: "radio" },
      // { text: "Recorrido", value: "recorrido" },
      // { text: "ISN", value: "isn" },
      // { text: "Indice", value: "indice" },

      // { text: "Domicilio", value: "domicilio" },

      // { text: "Medidor", value: "medidor" },

      // { text: "Detalle", value: "detalle" },
      // { text: "Comentario", value: "comentario" },
      // { text: "Telefono", value: "telefono" },
      // { text: "Mail", value: "mail" },
      // { text: "Contratista", value: "contratista" },
    ],
    headersTareas: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      {
        text: "Inicio",
        value: "inicioTramite",
        class: "black white--text",
        sortable: true,
      },
      { text: "Vencimiento", value: "vencimiento", class: "black white--text" },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headersTareasAsignadas: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Inicio", value: "inicioTarea", class: "black white--text" },
      {
        text: "Vencimiento",
        value: "vencimiento",
        class: "black white--text",
      },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Estado",
        value: "estado",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],

    headersTareasAsignadasContratista: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Inicio", value: "inicioTarea", class: "black white--text" },
      {
        text: "Vencimiento",
        value: "vencimiento",
        class: "black white--text",
      },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],

    headersTareasDespachadas: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Inicio", value: "inicioTarea", class: "black white--text" },
      { text: "Vencimiento", value: "vencimiento", class: "black white--text" },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Cuadrilla",
        value: "cuadrillaDescripcion",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headersTareasConcluidas: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Inicio", value: "inicioTarea", class: "black white--text" },
      { text: "Vencimiento", value: "vencimiento", class: "black white--text" },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Fecha de Conclusión",
        value: "fechaOperacion",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headersTareasInspeccionadas: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Inicio", value: "inicioTarea", class: "black white--text" },
      { text: "Vencimiento", value: "vencimiento", class: "black white--text" },
      { text: "Barrio", value: "barrio", class: "black white--text" },
      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Fecha de Inspeccion",
        value: "fechaOperacion",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headersTareasCanceladas: [
      {
        text: "Identificador",
        value: "identificador",
        class: "black white--text",
      },
      { text: "Titular", value: "titular", class: "black white--text" },
      { text: "Inicio", value: "inicioTarea", class: "black white--text" },
      { text: "Vencimiento", value: "vencimiento", class: "black white--text" },
      { text: "Barrio", value: "barrio", class: "black white--text" },

      {
        text: "Motivo",
        value: "descripcionMotivo",
        class: "black white--text",
      },
      {
        text: "Fecha de Cancelacion",
        value: "fechaOperacion",
        class: "black white--text",
      },
      // { text: "Contratista", value: "contratista" },
      // { text: "Acciones", value: "actions", sortable: false },
    ],
    //
    dialogoconfirmaranularreclamo: false,
    dialogoconfirmaranulardocumento: false,
    dialogomensajeanular: false,
    mensajedeldialogoanular: "",
    colordialogoanular: "",
    dialogomensaje: false,
    mensajedeldialogo: "",
    colordialogo: "",

    dialogoanulardocumento: false,
    mensajedeldialogoanulardocumento: "",
    colordialogoanulardocumento: "",
    dialogoanular: false,
    //mensajedeldialogoanular: "",
    //dialogomensajeanular: false,
    //colordialogoanular: "",
    dialogFechaDesde: false,
    dialogFechaHasta: false,
    FechaDesde: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 2,
    )
      .toISOString()
      .substr(0, 10),
    Fechahasta: new Date().toISOString().substr(0, 10),
    //urlBase: "https://localhost:7278", /////ESTO DEBERIA IR EN OTRA PARTE/////
    //url: "",
    numeroreclamo: "",
    numerodocumento: "",
    listareclamosdespachados: [],
    //colorSnackBar: "red",
    //snackbar: false,
    //mensajeSnackBar: null,
    selectedTab: null, //SIRVE PARA LAS PESTAÑAS
    dialog: false, /////////////////////////NO SE PARA QUE SIRVE////////////////////////
    arrayc: [],
    arraycc: [],

    editedIndex: -1, /////////////////////////NO SE PARA QUE SIRVE////////////////////////
  }),
  watch: {
    FechaDesde() {
      this.listareclamos = this.ListarReclamos();
    },
    FechaHasta() {
      this.listareclamos = this.ListarReclamos();
    },
    dialog(val) {
      ////NO SE QUE HACE
      val || this.close();
    },
  },

  computed: {
    headersTareasConcluidasVisibles() {
      // Filtra las columnas visibles según el valor de idRol
      if (this.idRol === 2) {
        return this.headersTareasConcluidas;
      } else {
        // Copia todas las columnas excepto la de "Contratista"
        return this.headersTareasConcluidas.filter(
          (column) => column.value !== "contratista",
        );
      }
    },

    headersTareasAsignadasTipo() {
      return this.$store.getters.usuario.idRol === 2
        ? this.headersTareasAsignadas
        : this.headersTareasAsignadasContratista;
    },

    formattedTareas() {
      return this.tablaTareas.map((tarea) => {
        return {
          ...tarea,
          vencimiento: new Date(tarea.vencimiento),
        };
      });
    },
  },

  mounted() {
    console.log("La id del contratista es: ");
    console.log(this.$store.getters.usuario.idContratista);

    if (this.timer) {
      clearTimeout(this.timer); // Limpia el temporizador
    }

    // if (this.$store.getters.usuario.idContratista == null) {
    //   if (this.$store.getters.usuario.idCuadrilla != null) {
    //   } else {
    //     this.recuperarTareas();
    //   }
    // } else {
    //   console.log("La id del contratista antes de las tareas asignadas es: ");
    //   console.log(this.$store.getters.usuario.idContratista);
    //   this.recuperarTareasAsignadasContratista(
    //     this.$store.getters.usuario.idContratista
    //   );
    // }

    if (this.$store.getters.usuario.idRol == 2) {
      this.recuperarTareas();
    }
    if (this.$store.getters.usuario.idRol == 3) {
      this.recuperarTareasAsignadasContratista(
        this.$store.getters.usuario.idContratista,
      );
    }
    if (this.$store.getters.usuario.idRol == 4) {
      this.recuperarTareasDespachadasCuadrilla(
        this.$store.getters.usuario.idCuadrilla,
      );
    }

    if (
      this.$store.getters.usuario.idContratista == null &&
      this.$store.getters.usuario.idRol == 3
    ) {
      this.recuperarTareasAsignadasContratista(
        this.$store.getters.usuario.idContratista,
      );
    }

    // if (this.$store.getters.usuario.idRol == 5) {
    // }

    //this.recuperarMaterialesTareas();
    //this.recuperarEdiciones();
    //this.recuperarTareasAsignadas();
    //this.recuperarTareasCanceladas();
    this.listadotiposdetareas =
      this.$store.getters.usuario.idRol == 2
        ? [
            { nombre: "Generadas" },
            { nombre: "Asignado" },
            { nombre: "Concluido" },
            { nombre: "Inspeccionado" },
            { nombre: "Cancelado" },
          ]
        : this.$store.getters.usuario.idRol == 3
        ? [
            { nombre: "Pendientes" },
            { nombre: "Despachadas" },
            { nombre: "Concluido" },
          ]
        : this.$store.getters.usuario.idRol == 5
        ? [
            { nombre: "Generadas" },
            { nombre: "Asignado" },
            //{ nombre: "Despachadas" },
            { nombre: "Concluido" },
            { nombre: "Inspeccionado" },
            { nombre: "Cancelado" },
          ]
        : [];

    console.log("La id del contratista antes de recuperar Contratistas es: ");
    console.log(this.$store.getters.usuario.idContratista);

    this.getListarContratistas();

    console.log("La id del contratista despues de recuperar Contratistas es: ");
    console.log(this.$store.getters.usuario.idContratista);

    //this.VerificarLoginUsuario();
    ///DEBERIA ASIGNAR EL RECLAMO
    //this.listareclamos = this.ListarReclamos();
  },
  methods: {
    generarCertificadoManoObra() {
      console.log("Generar Certificado Mano Obra");
      this.$refs.modalCertificadoManoObra.abrirDialog();
    },

    opcionesTarea(item) {
      this.$refs.modalTareaCuadrilla.abrirDialog(item);
    },

    async getListarContratistas() {
      console.log("Ingreso en listar contratistas");
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      //var listacontratistas = [];

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.listaContratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },
    async cambioContratista() {
      console.log("El contratista es: ");
      console.log(this.contratistaSeleccionado);
      this.$store.getters.usuario.idContratista = this.contratistaSeleccionado;
      if (this.selectedTab == 1) {
        await this.recuperarTareasAsignadasContratista(
          this.$store.getters.usuario.idContratista,
        );
      }
      if (this.selectedTab == 2) {
        await this.recuperarTareasConcluidas(
          this.$store.getters.usuario.idContratista,
        );
      }
      if (this.selectedTab == 3) {
        await this.recuperarTareasInspeccionadas(
          this.$store.getters.usuario.idContratista,
        );
      }
      if (this.selectedTab == 4) {
        await this.recuperarTareasCanceladas(
          this.$store.getters.usuario.idContratista,
        );
      }
    },
    updateSortBy(newSortBy) {
      if (this.sortBy === newSortBy) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = newSortBy;
        this.sortDesc = false;
      }
    },

    getColor(estado) {
      //console.log("Ingreso en la funcion getCOlor");
      if (estado == 48) return "red";
      if (estado == 23) return "orange";
      else return "white";
    },
    handleDatesSelected(dates) {
      this.selectedDates = dates;
      console.log("El rango de fecha es:");
      console.log(this.selectedDates);
      this.recuperarTareas();
    },
    asignarTodasLasTareas() {
      console.log("Ingreso en asignar todas las tarea a los contratista");
      this.$refs.abrirModalInsert_Update.asignarTodasTareaContratista(
        this.tablaTareas,
      );
    },

    getTextoEstado(valor) {
      if (valor == 1) {
        return "Asignada";
      } else {
        return "Despachada";
      }
    },

    generarExcelTareas() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Datos");

      // Agrega datos a la hoja de cálculo
      worksheet.addRow([
        "Distrito",
        "Radio",
        "Recorrido",
        "Identificador",
        "Vencimiento",
        "Titular",
        "Domicilio",
        "Barrio",
        "Medidor",
        "Motivo Tramite",
        "Detalle",
        "Comentario",
        "Telefono",
        "Mail",
      ]);

      console.log("La tab seleccionada es");
      console.log(this.tabSeleccionada);

      switch (this.tabSeleccionada) {
        case 0:
          this.$store.getters.usuario.idRol == 2
            ? this.tablaTareas.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              })
            : this.$store.getters.usuario.idRol == 3
            ? this.tablaTareasAsignadas.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              })
            : this.tablaTareasDespachadasCuadrilla.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              });

          break;
        case 1:
          this.$store.getters.usuario.idRol == 2
            ? this.tablaTareasAsignadas.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              })
            : this.tablaTareasDespachadas.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              });
          break;
        case 2:
          this.tablaTareasConcluidas.forEach((tarea) => {
            worksheet.addRow([
              tarea.distrito,
              tarea.radio,
              tarea.recorrido,
              tarea.identificador,
              tarea.vencimiento,
              tarea.titular,
              tarea.domicilio,
              tarea.barrio,
              tarea.medidor,
              tarea.motivo,
              tarea.detalle,
              tarea.comentario,
              tarea.telefono,
              tarea.mail,
            ]);
          });
          break;
        case 3:
          this.tablaTareasInspeccionadas.forEach((tarea) => {
            worksheet.addRow([
              tarea.distrito,
              tarea.radio,
              tarea.recorrido,
              tarea.identificador,
              tarea.vencimiento,
              tarea.titular,
              tarea.domicilio,
              tarea.barrio,
              tarea.medidor,
              tarea.motivo,
              tarea.detalle,
              tarea.comentario,
              tarea.telefono,
              tarea.mail,
            ]);
          });
          break;
        case 4:
          this.tablaTareasCanceladas.forEach((tarea) => {
            worksheet.addRow([
              tarea.distrito,
              tarea.radio,
              tarea.recorrido,
              tarea.identificador,
              tarea.vencimiento,
              tarea.titular,
              tarea.domicilio,
              tarea.barrio,
              tarea.medidor,
              tarea.motivo,
              tarea.detalle,
              tarea.comentario,
              tarea.telefono,
              tarea.mail,
            ]);
          });
          break;
        default:
          this.$store.getters.usuario.idRol == 2 ||
          this.$store.getters.usuario.idRol == 5
            ? this.tablaTareas.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              })
            : this.$store.getters.usuario.idRol == 3
            ? this.tablaTareasAsignadas.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              })
            : this.tablaTareasDespachadasCuadrilla.forEach((tarea) => {
                worksheet.addRow([
                  tarea.distrito,
                  tarea.radio,
                  tarea.recorrido,
                  tarea.identificador,
                  tarea.vencimiento,
                  tarea.titular,
                  tarea.domicilio,
                  tarea.barrio,
                  tarea.medidor,
                  tarea.motivo,
                  tarea.detalle,
                  tarea.comentario,
                  tarea.telefono,
                  tarea.mail,
                ]);
              });
          break;
      }

      // if (this.tabSeleccionada == 0) {

      // }

      // Genera el archivo Excel
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "datos.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    verDetalleTareaInspeccionada(datos) {
      this.$refs.modalTareaDetalle.AbrirModalInspeccionada(datos);
    },

    verDetalleTarea(datos) {
      this.$refs.modalTareaDetalle.AbrirModal(datos);
    },

    mostrarDateTimePicker() {
      console.log("Ingreso en mostrar el time picker");
      this.menuDateTimePicker = true;
    },
    ocultarDateTimePicker() {
      this.menuDateTimePicker = false;
      this.recuperarTareas();
    },

    getEstado(estado) {
      console.log("Ingreso en la funcion getColor");
      if (estado == 1) {
        this.iniciarTarea = true;
      } else {
        this.iniciarTarea = true;
      }
    },

    async iniciarTareaCuadrilla(tareaSeleccionada) {
      this.iniciarTarea = true;
      console.log("la tarea seleccionada para iniciar es: ");
      console.log(tareaSeleccionada.idTarea);
      console.log("el codigo de usuario");
      console.log(this.$store.getters.usuario);
      var respuesta;
      this.url = this.$store.state.urlBase + "Task/iniciarTareaCuadrilla";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      var obj = {
        idTarea: tareaSeleccionada.idTarea,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("El obj a enviar es:");
      console.log(obj);

      respuesta = await axios
        .post(this.url, obj, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de la tarea cancelada es:");

      this.tablaTareasCanceladas = respuesta;

      console.log(this.tablaTareasCanceladas);

      this.recuperarTareasDespachadasCuadrilla(
        this.$store.getters.usuario.idCuadrilla,
      );
    },

    async finalizarTareaCuadrilla(tareaSeleccionada) {
      this.iniciarTarea = false;
      console.log("la tarea seleccionada es: ");
      console.log(tareaSeleccionada);
      let datos = [];
      datos.push({
        idCuadrilla: this.$store.getters.usuario.idCuadrilla,
        idTarea: tareaSeleccionada.idTarea,
        identificador: tareaSeleccionada.identificador,
      });
      this.$router.push({
        name: "ArmarCajon",
        params: { datos },
      });
    },

    cancelarTareaModal(datosTarea) {
      console.log("LOs datos de la tarea a cancelar son:");
      console.log(datosTarea);
      this.idTareaCancelar = datosTarea.idTarea;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea cancelar la tarea " + datosTarea.idTarea + " ?",
        2,
        "red",
        "Aviso",
      );
    },

    async cancelarTarea(valor) {
      console.log("El valor es");
      console.log(valor);
      if (valor == true) {
        var respuesta;
        console.log("Ingreso en cancelarTarea");
        this.url = this.$store.state.urlBase + "Task/cancelarTarea";

        const config = {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
          },
        };

        var obj = {
          idTarea: this.idTareaCancelar,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        respuesta = await axios
          .post(this.url, obj, config)
          .then((response) => response.data);

        console.log("El resultado de la respuesta de la tarea cancelada es:");

        this.tablaTareasCanceladas = respuesta;

        this.recuperarTareasAsignadas();

        console.log(this.tablaTareasCanceladas);
      }
    },

    cambiarTab(index) {
      console.log("El index de la tab es");
      console.log(index);
      console.log("El id Rol es");
      console.log(this.$store.getters.usuario.idRol);

      if (
        index == 0 &&
        (this.$store.getters.usuario.idRol == 2 ||
          this.$store.getters.usuario.idRol == 5)
      ) {
        if (this.fecha != "") {
          this.recuperarTareas();
        }
      }
      if (index == 0 && this.$store.getters.usuario.idRol == 3) {
        this.recuperarTareasAsignadasContratista(
          this.$store.getters.usuario.idContratista,
        );
      }
      if (
        index == 1 &&
        (this.$store.getters.usuario.idRol == 2 ||
          this.$store.getters.usuario.idRol == 5)
      ) {
        if (this.$store.getters.usuario.idRol == 5) {
          this.recuperarTareasAsignadasContratista(
            this.$store.getters.usuario.idContratista,
          );
        } else {
          this.recuperarTareasAsignadas();
        }
      }
      if (index == 1 && this.$store.getters.usuario.idRol == 3) {
        this.recuperarTareasDespachadasContratista(
          this.$store.getters.usuario.idContratista,
        );
      }
      if (
        index == 2 &&
        (this.$store.getters.usuario.idRol == 2 ||
          this.$store.getters.usuario.idRol == 5)
      ) {
        //console.log("Tareas Concluidas");
        this.recuperarTareasConcluidas();
      }
      if (index == 2 && this.$store.getters.usuario.idRol == 3) {
        this.recuperarTareasConcluidasContratistas(
          this.$store.getters.usuario.idContratista,
        );
      }
      if (index == 3) {
        this.recuperarTareasInspeccionadas();
      }
      if (index == 4) {
        this.recuperarTareasCanceladas();
      }
      if (this.$store.getters.usuario.idRol == 4) {
        this.recuperarTareasDespachadasCuadrilla(
          this.$store.getters.usuario.idCuadrilla,
        );
      }

      this.tabSeleccionada = index;
    },

    filtrarTareas(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },

    // filtrarTareasAsignadas(value, query) {
    //   console.log("Estoy filtrando las tareas asignadas");
    //   return (
    //     value != null &&
    //     query != null &&
    //     typeof value === "string" &&
    //     value.toString().toLowerCase().includes(query.toLowerCase())
    //   );
    // },

    filtrarTareasAsignadas(value, query, item) {
      //console.log("Valor:", value, "Búsqueda:", query, "Item:", item);
      if (!value || !query) return false;

      if (value === item.estado) {
        const estadoTexto = this.getTextoEstado(item.estado);
        //console.log("Comparando estado:", estadoTexto);
        return estadoTexto.toLowerCase().includes(query.toLowerCase());
      }

      return value.toString().toLowerCase().includes(query.toLowerCase());
    },
    filtrarTareasConcluidas(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },
    filtrarTareasInspeccionadas(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },
    filtrarTareasDespachadas(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },
    filtrarTareasCanceladas(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },

    filtrarTareasDespachadasCuadrilla(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },

    asignarTareaContratista(datos) {
      console.log("Ingreso en asignar tarea contratista");
      this.$refs.abrirModalInsert_Update.asignarTareaContratista(datos);
    },

    asignarTareaCuadrilla(datos) {
      console.log("Ingreso en asignar tarea");
      if (
        this.$store.getters.usuario.idRol == 5 &&
        (this.$store.getters.usuario.idContratista == "" ||
          this.$store.getters.usuario.idContratista == null)
      ) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Debe seleccionar un contratista para poder asignar la tarea",
          1,
          "red",
          "Aviso",
        );
      } else {
        this.$refs.abrirModalInsert_Update.asignarTareaCuadrilla(datos);
      }
    },

    async recuperarTareasDespachadasCuadrilla(idCuadrilla) {
      var respuesta;

      this.url =
        this.$store.state.urlBase +
        "Task/recuperarTareasDespachadasCuadrilla?idCuadrilla=" +
        idCuadrilla;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las tareas despachadas es:");

      this.tablaTareasDespachadasCuadrilla = respuesta;

      console.log(this.tablaTareasDespachadasCuadrilla);
    },

    async recuperarTareas() {
      console.log("Ingreso en recuperar tarea comerciales");
      var respuesta;

      this.tablaTareas = [];

      var url = this.$store.state.urlBase + "Task";

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.getters.usuario.token}`,
          "Content-Type": "application/json",
        },
      };

      var datos = {
        fechas: this.selectedDates,
      };

      console.log("El id distrito es:");
      console.log(this.$store.getters.usuario.idDistrito);
      console.log(typeof this.selectedDates);

      console.log("El tipo de datos es:");
      console.log(typeof this.selectedDates);
      console.log(this.selectedDates[0]);
      console.log(typeof this.selectedDates[0]);

      datos.fechas.push(this.$store.getters.usuario.idDistrito);

      const params = new URLSearchParams();

      datos.fechas.forEach((fecha) => params.append("fechas", fecha));

      console.log("Lo que hay en fechas es: ");
      console.log(datos.fechas);

      respuesta = await axios
        .get(`${url}?${params.toString()}`, config)
        //.get(url, config, datos)
        .then((response) => response.data);

      this.tablaTareas = respuesta;

      console.log("Los datos antes de ser filtrados");
      console.log(this.tablaTareas);
      // Mapa para almacenar identificadores ya vistos
      const identificadoresVistos = new Map();

      // Filtrar y actualizar el array de datos
      const datosFiltrados = this.tablaTareas.filter((dato) => {
        const identificador = dato.identificador;

        // Si el identificador ya fue visto, agregar el "detalle" al primer identificador y retornar false para eliminar el segundo
        if (identificadoresVistos.has(identificador)) {
          identificadoresVistos.get(identificador).comentario = dato.detalle;
          return false;
        }

        // Almacenar el identificador para verificar en el futuro
        identificadoresVistos.set(identificador, dato);

        return true;
      });

      // const identificadoresVistos2 = new Map();

      // // Filtrar y actualizar el array de datos
      // const datosFiltrados2 = this.tablaTareas.filter((dato) => {
      //   const identificador = dato.identificador;

      //   // Si el identificador ya fue visto, agregar el "detalle" al primer identificador y retornar false para eliminar el segundo
      //   if (identificadoresVistos2.has(identificador)) {
      //     identificadoresVistos2.get(identificador).indice = dato.indice;
      //     return false;
      //   }

      //   // Almacenar el identificador para verificar en el futuro
      //   identificadoresVistos2.set(identificador, dato);

      //   return true;
      // });

      console.log("Los datos filtrados son: ");
      console.log(datosFiltrados);

      this.tablaTareas = datosFiltrados;

      console.log("Los datos de la tabla de tareas es:");
      console.log(this.tablaTareas);

      // const tareasAsignadas = this.recuperarTareasAsignadas();

      // console.log("Las tareas asignadas son");
      // console.log(tareasAsignadas);
    },

    async recuperarTareasAsignadas() {
      var respuesta;

      this.url =
        this.$store.state.urlBase +
        "Task/recuperarTareasAsignadas?idDistrito=" +
        this.$store.getters.usuario.idDistrito;

      console.log("El id del distrito es:");
      console.log(this.$store.getters.usuario.idDistrito);

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("1-El resultado de la respuesta de las tareas asignadas es:");

      this.tablaTareasAsignadas = respuesta;

      console.log(this.tablaTareasAsignadas);

      // const isnsAsignadas = this.tablaTareasAsignadas.map((tarea) => tarea.ISN);

      // const tablaTareasFiltradas = this.tablaTareas.filter(
      //   (tarea) => !isnsAsignadas.includes(tarea.ISN)
      // );

      // console.log("Las tareas sin las tareas asignadas son");
      // console.log(tablaTareasFiltradas);

      // console.log(this.tablaTareasAsignadas);
    },

    inspeccionarTarea(tareaSeleccionada) {
      console.log("la tarea seleccionada es");
      console.log(tareaSeleccionada);
      this.$router.push({
        name: "inspeccionarTarea",
        params: { tareaSeleccionada },
      });
    },

    async recuperarTareasAsignadasContratista(idContratista) {
      var respuesta;
      this.tablaTareasAsignadas = [];

      if (idContratista == null) {
        idContratista = 2;
      }

      console.log("Igreso recuperarTareasAsignadasContratista");

      // this.url =
      //   this.$store.state.urlBase +
      //   "Task/recuperarTareasAsignadasContratistas?idContratista=" +
      //   idContratista;

      this.url = `${this.$store.getters.urlBase}Task/recuperarTareasAsignadasContratistas?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      const data = {
        idContratista: idContratista,
      };

      console.log(data);

      respuesta = await axios
        .get(this.url, config, data)
        .then((response) => response.data);

      console.log(
        "El resultado de la respuesta de las tareas asignadas de los contratistas es:",
      );

      this.tablaTareasAsignadas = respuesta;

      console.log(this.tablaTareasAsignadas);
    },

    async recuperarTareasConcluidas() {
      var respuesta;

      this.tablaTareasConcluidas = [];

      this.url =
        this.$store.state.urlBase +
        `Task/recuperarTareasConcluidas?idDistrito=${this.$store.getters.usuario.idDistrito}`;

      console.log(this.url);

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las tareas concluidas es:");

      this.tablaTareasConcluidas = respuesta;

      console.log(this.tablaTareasConcluidas);
    },

    async recuperarTareasInspeccionadas() {
      var respuesta;

      this.tablaTareasInspeccionadas = [];

      // this.url =
      //   this.$store.state.urlBase + "Task/recuperarTareasInspeccionadas";

      this.url =
        this.$store.state.urlBase +
        `Task/recuperarTareasInspeccionadas?idDistrito=${this.$store.getters.usuario.idDistrito}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log(
        "El resultado de la respuesta de las tareas Inspeccionadas es:",
      );

      console.log(respuesta);

      this.tablaTareasInspeccionadas = respuesta;

      console.log(this.tablaTareasInspeccionadas);
    },

    async recuperarTareasCanceladas() {
      var respuesta;

      this.tablaTareasCanceladas = [];

      this.url =
        this.$store.state.urlBase +
        `Task/recuperarTareasCanceladas?idDistrito=${this.$store.getters.usuario.idDistrito}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las tareas Canceladas es:");

      this.tablaTareasCanceladas = respuesta;

      console.log(this.tablaTareasCanceladas);
    },

    async recuperarTareasDespachadasContratista(idContratista) {
      var respuesta;

      console.log(idContratista);

      this.url =
        this.$store.state.urlBase +
        `Task/recuperarTareasDespachadasContratistas?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      // var obj = {
      //   idContratista: idContratista,
      //   idDistrito: this.$store.getters.usuario.idDistrito,
      // };

      // console.log("Los datos de despachadas contratista");
      // console.log(obj);

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las tareas despachadas es:");

      this.tablaTareasDespachadas = respuesta;

      console.log(this.tablaTareasDespachadas);
    },

    async recuperarTareasConcluidasContratistas(idContratista) {
      var respuesta;

      this.url =
        this.$store.state.urlBase +
        "Task/recuperarTareasConcluidasContratistas?idContratista=" +
        idContratista;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las tareas concluidas es:");

      this.tablaTareasConcluidas = respuesta;

      console.log(this.tablaTareasConcluidas);
    },

    recargarListadoAsignados() {
      this.recuperarTareasAsignadasContratista(
        this.$store.getters.usuario.idContratista,
      );
    },

    recargarListado() {
      console.log("Ingreso en recargar tareas");
      this.recuperarTareas();
    },

    async recuperarMaterialesTareas() {
      var respuesta;

      this.url =
        this.$store.state.urlBase + "ProyectosNT/ListadoMaterialesTareas";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de los materiales es:");
      console.log(respuesta);

      this.tablaTareasAsignadas = respuesta;
    },

    AbrirModal(tipo) {
      this.$refs.abrirModalInsert_Update.openModal(tipo);
    },

    abrirTareasCuadrilla(datos) {
      this.$router.push({
        name: "TareasCuadrillas",
        params: { datos },
      });
    },

    concluirTareaCuadrilla(datos) {
      this.$refs.abrirModalTareaCuadrilla.abrirModalTareaCuadrilla(datos);
    },

    async recuperarEdiciones() {
      var respuesta;

      this.url = this.$store.state.urlBase + "ProyectosNT/Ediciones";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las ediciones es:");
      console.log(respuesta);

      this.tablaTareasConcluidas = respuesta;
    },

    // async recuperarTareasCanceladas() {
    //   var respuesta;

    //   this.url = this.$store.state.urlBase + "ProyectosNT/TareasCanceladas";

    //   const config = {
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
    //     },
    //   };

    //   respuesta = await axios
    //     .get(this.url, config)
    //     .then((response) => response.data);

    //   console.log("El resultado de la respuesta tipicos relacionados es:");
    //   console.log(respuesta);

    //   this.tablaTareasCanceladas = respuesta;
    // },

    async agregarTarea() {
      console.log("Ingresoe en agregar item constructivo");
      this.$refs.modalTareas.agregarTarea();
    },

    async editarTarea(item) {
      console.log("INgresoe en la edicion de item constructivo");
      console.log(item);
      this.$refs.modalTareas.editarTarea(item);
    },

    fechaConvertida(fecha) {
      const año = fecha.substring(0, 4);
      const mes = fecha.substring(4, 6);
      const día = fecha.substring(6);

      // Crear un objeto Date con el formato dd/mm/aaaa
      const fechaFormateada = new Date(`${mes}/${día}/${año}`);

      // Obtener el día, mes y año con ceros a la izquierda si es necesario
      const díaFormateado = String(fechaFormateada.getDate()).padStart(2, "0");
      const mesFormateado = String(fechaFormateada.getMonth() + 1).padStart(
        2,
        "0",
      );
      const añoFormateado = fechaFormateada.getFullYear();

      // Crear la cadena de fecha en formato dd/mm/aaaa
      const fechaFinal = `${díaFormateado}/${mesFormateado}/${añoFormateado}`;

      //console.log("La fecha para mostrar es: ");
      //console.log(fechaFinal); // Salida: 03/05/2023

      return fechaFinal;
    },

    // recargarTareas() {
    //   this.recuperarTareas();
    // },

    convertirFormatoFecha(fecha) {
      const partesFecha = fecha.split("-");
      const fechaConvertida =
        partesFecha[0].substring(2) + partesFecha[1] + partesFecha[2];
      console.log("La fecha convertida es ");
      console.log(fechaConvertida);
      return fechaConvertida;
    },
  },
};
</script>
<style scoped>
.custom-header {
  background-color: lightblue; /* Cambia el color de fondo del encabezado */
  color: white; /* Cambia el color del texto del encabezado */
}
</style>
